"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Response = void 0;
const ReturnUserDefinedTool_1 = require("../../../types/ReturnUserDefinedTool");
exports.Response = ReturnUserDefinedTool_1.ReturnUserDefinedTool.optional();
